import { Chart } from '@antv/g2'
import moment from 'moment'
import React from 'react'

export const DashboardLineChart: React.FC<{ data: any[]; type: 'line' | 'interval' }> = ({ data, type }) => {
  const containerEl = React.useRef<HTMLDivElement>(null)
  const [chart, setChart] = React.useState<Chart>()

  React.useEffect(() => {
    if (!containerEl.current) {
      return
    }
    if (!chart) {
      const chart = new Chart({
        container: containerEl.current,
        autoFit: true,
        height: 300,
      })
      setChart(chart)
    }
  }, [])

  React.useEffect(() => {
    if (chart) {
      chart.clear()

      chart.data(data)
      chart.scale('workload', {
        nice: true,
      })

      chart.legend('selfId', {
        position: 'top',
        itemWidth: 120,
        allowAllCanceled: true,
        itemName: {
          formatter: (text) => {
            return data.find((d) => d.selfId === text).name
          },
        },
        marker: {
          symbol: 'square',
        },
      })

      if (type === 'line') {
        chart.tooltip({
          shared: true,
          showCrosshairs: true,
          title: (_, item) =>
            `${item.date} (${moment().year(item.year).week(item.week).startOf('week').format('YYYY-MM-DD')} - ${moment()
              .year(item.year)
              .week(item.week)
              .endOf('week')
              .format('YYYY-MM-DD')})`,
          customItems: (items) => {
            return items.map((item) => ({
              ...item,
              name: item.data.name,
              value: item.data.workload.toFixed(1),
            }))
          },
        })
        chart.line().position('date*workload').color('selfId')
      } else {
        chart.interval().position('date*workload').color('selfId').adjust('stack')
        chart.tooltip({
          shared: true,
          showMarkers: false,
          title: (_, item) =>
            `${item.date} (${moment().year(item.year).week(item.week).startOf('week').format('YYYY-MM-DD')} - ${moment()
              .year(item.year)
              .week(item.week)
              .endOf('week')
              .format('YYYY-MM-DD')})`,
          customItems: (items) => {
            return items.map((item) => ({
              ...item,
              value: item.data.workload.toFixed(1),
              projectName: item.data.name,
            }))
          },
        })
      }

      chart.render()
    }
  }, [data])

  return <div ref={containerEl}></div>
}
